import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=6c3b8300&scoped=true&"
import script from "./Especialidades.vue?vue&type=script&lang=js&"
export * from "./Especialidades.vue?vue&type=script&lang=js&"
import style0 from "./Especialidades.vue?vue&type=style&index=0&id=6c3b8300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b8300",
  null
  
)

export default component.exports